import React from "react";
import classNames from "classnames";
import {Button, Spinner} from "reactstrap";
import "./buttonIcon.sass";
import {IconSource} from "../../../shared/enums/iconSource";
import Icon from "../common/icon/icon";

export type ButtonType =
  | "primary"
  | "primary-negative"
  | "secondary"
  | "secondary-negative"
  | "inline"
  | "accessory";

export interface IButtonIconProps {
  type?: ButtonType;
  icon?: IconSource;
  isDisabled?: boolean;
  isClickable?: boolean;
  isReadOnly?: boolean;
  isBusy?: boolean;
  children?: any;
  onClick?: () => void;
  isValid?: boolean;
  testId?: string | null;
}

const ButtonIcon: React.FC<IButtonIconProps> = ({
  type = "primary",
  icon,
  isDisabled,
  isClickable = true,
  isReadOnly = false,
  isBusy = false,
  children,
  onClick,
  isValid = true,
  testId
}) => {
  return (
    <Button
      data-testid={testId ?? "button-icon"}
      className={classNames("button-icon", {
        "primary-button": type === "primary",
        "primary-negative-button": type === "primary-negative",
        "secondary-button": type === "secondary",
        "secondary-negative-button": type === "secondary-negative",
        "inline-button": type === "inline",
        "accessory-button": type === "accessory",
        busy: isBusy,
        error: !isValid,
        clickable: isClickable,
        readonly: isReadOnly
      })}
      onClick={(e) => {
        if (!isBusy && isClickable && onClick) {
          e.stopPropagation();
          onClick();
        }
      }}
      disabled={isDisabled}
    >
      <div>
        {icon && <Icon source={icon} />}
        <span className="button-text">{children}</span>
        {isBusy && (
          <div className="spinner">
            <Spinner />
          </div>
        )}
      </div>
    </Button>
  );
};

export default ButtonIcon;
